import { connect } from 'react-redux';
import { getCurrentQuickUsage, getCurrentQuickCycle, getCurrentQuickPlan } from 'reducers';
import { findCurrent as fetchCycles } from 'billing/cycles/quick/actions';
import { findCurrent as findCurrentUsage } from 'subscriptions/usage/quick/actions';
import DataRemaining from './DataRemaining';

const mapStateToProps = (state, { subId }) => {
  const usage = getCurrentQuickUsage(state, subId);

  return {
    usage,
    currentCycle: getCurrentQuickCycle(state, subId),
    currentPlan: getCurrentQuickPlan(state, subId),
  }
};

const mapDispatchToProps = {
  fetchCycles,
  findCurrentUsage,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataRemaining);
